import React from 'react';
import { useTheme } from '@mui/material';
import { observer } from 'mobx-react';
import { Axis, LEFT, RIGHT } from 'react-d3-axis-mod';
const YScaleBar = observer(function ({ model, orientation, }) {
    const { ticks } = model;
    const theme = useTheme();
    return ticks ? (React.createElement(Axis, { ...ticks, shadow: 2, format: (n) => n, style: { orient: orientation === 'left' ? LEFT : RIGHT }, bg: theme.palette.background.default, fg: theme.palette.text.primary })) : null;
});
export default YScaleBar;
